<div class="searchBar-container">
  <abc-drop-down-button
    [height]="'36px'"
    class="search-type-dropdown-button"
    [icon]="currentFilterOption?.icon"
    displayExpr="caption"
    [dropDownOptions]="{ width: 180 }"
    [items]="filterOptions"
    keyExpr="searchMode"
    (onItemClick)="filterOptionChanged($event)"
  ></abc-drop-down-button>
  <abc-text-box
    [height]="'36px'"
    (onValueChanged)="searchTermChanged($event)"
    [valueChangeEvent]="'keyup'"
    [placeholder]="res.get('searchBar-placeholder')"
  >
  </abc-text-box>
</div>
